import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import millify from "millify";
import history from "./_Utils/History";

// Routes
import { CURRENCY, NEWS } from "./_Utils/Routes";

// Assets
import dollar from "../Assets/dollar-sign.svg";
import exchanges from "../Assets/statExchanges.svg";
import marketCap from "../Assets/marketCap.svg";
import vol from "../Assets/vol.svg";
import markets from "../Assets/markets.svg";
import newsImg from "../Assets/cryptoCardBg.svg";
import box4 from "../Assets/box4.svg";
import Loader from "../Assets/loader.gif";

//Action
import { ClearLogs, getCurrency, getNews, NavTab } from "../Actions";

class Statistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: {},
      coins: [],
      news: [],
      loader: true,
    };
  }

  componentDidMount() {
    this.props.getCurrency(10);
    this.props.getNews("Cryptocurrency", 10);
  }

  componentDidUpdate(prevProps, nextState) {
    //Coin and stats
    if (
      this.props.currencyStatus === "success" &&
      prevProps.currencyData !== this.props.currencyData
    ) {
      this.props.ClearLogs();
      this.setState({
        stats: this.props.currencyData.data.stats,
        coins: [this.state.coins, ...this.props.currencyData.data.coins],
        loader: false,
      });
    }

    //News
    if (
      this.props.newsStatus !== prevProps.newsStatus &&
      prevProps.newsData !== this.props.newsData
    ) {
      this.props.ClearLogs();
      this.setState({
        news: this.props.newsData?.value,
      });
    }
  }

  // Return string before space character
  reduceName(name) {
    var newName = "";
    for (var i = 0; i < name?.length; i++) {
      if (name[i] === " ") break;
      newName = newName + name[i];
    }

    return newName;
  }

  cryptoCards(coinsData) {
    return (
      <div
        className="Currencies_CryptoOuterCard"
        key={coinsData.uuid}
        onClick={() => {
          this.props.NavTab(2);
          history.push({
            pathname: `/currency/detail/${coinsData.uuid}`,
            state: {
              coinId: coinsData.uuid,
            },
          });
        }}
      >
        <div className="Currencies_EmptyCryptoCard"></div>
        <div className="Currencies_CryptoInnerCard">
          <div className="Currencies_CryptoDescCard">
            <div className="Currencies_OuterHexShape">
              <div className="Currencies_InnerHexShape">
                <img src={coinsData.iconUrl} alt="Crypto Card Icon" />
              </div>
            </div>
            <div className="Currencies_Name">
              {this.reduceName(coinsData?.name)}
            </div>
            <div className="Currencies_CoinsData">
              <span>Price: {millify(parseInt(coinsData.price))} USD</span>
              <span>Market Cap: {millify(parseInt(coinsData.marketCap))}</span>
              <span>Daily Changes: {coinsData.change}%</span>
            </div>
            <div className="Currencies_ArrowBlock">
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
              <div className="Currencies_Arrow"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  newsCard(newsData) {
    return (
      <div className="News_NewsClipPathCard">
        <div className="News_NewsColorCard"></div>
        <div className="News_NewsInnerCard">
          <div className="News_ImgTitleCard">
            <div className="News_ImgClipPathCard">
              <div className="News_ImgInnerCard">
                {/* If image pass from server is undefiend */}
                {newsData.image !== undefined ? (
                  <img src={newsData.image.thumbnail.contentUrl} alt="Card" />
                ) : (
                  <img src={newsImg} alt="Card" />
                )}
              </div>
            </div>
            <div className="News_Title">{newsData.name}</div>
          </div>
          <div className="News_ShortDesc">{newsData.description}</div>
          <div className="News_NewsAuthor">
            <div className="News_AuthorName">{newsData.provider[0].name}</div>
            <div className="News_Timing">2 Hours Ago</div>
          </div>
        </div>
      </div>
    );
  }

  globalStatsCard(img, title, val) {
    return (
      <div className="Statistics_GlobalStatsOuterCard">
        <div className="Statistics_StatsColorCard"></div>
        <div className="Statistics_GlobalStatsInnerCard">
          <div className="Statistics_GSImgBlock">
            <img alt="Card" src={img} />
          </div>
          <div className="Statistics_GSDesc">
            <div className="Statistics_GSTitle">{title}</div>
            <div className="Statistics_GSData">{val}</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    // Local Variables for simplicity
    const stats = this.state.stats;
    const coins = this.state.coins;
    const news = this.state.news;

    if (this.state.loader) {
      return (
        <>
          <img src={Loader} alt="" className="Loader" />
        </>
      );
    }

    return (
      <div className="Statistics">
        <div className="Statistics_StatisticsOverFlow">
          {/* Global Stats */}
          <div className="Statistics_GlobalStats">
            <div className="Statistics_GlobalStatsTitle">Crypto Stats</div>
            <div className="Statistics_GlobalStatsCardsBlock">
              {this.globalStatsCard(
                dollar,
                "Total Currencies",
                millify(parseInt(stats.total))
              )}
              {this.globalStatsCard(
                exchanges,
                "Total Exchanges",
                millify(parseInt(stats.totalExchanges))
              )}
              {this.globalStatsCard(
                marketCap,
                "Total Market Cap",
                "$ " + millify(parseInt(stats.totalMarketCap))
              )}
              {this.globalStatsCard(
                vol,
                "Total 24th Vol",
                "$ " + millify(parseInt(stats.total24hVolume))
              )}
              {this.globalStatsCard(
                markets,
                "Total Markets",
                "$ " + millify(parseInt(stats.totalMarkets))
              )}
            </div>
          </div>

          {/* Crypto Cards */}
          <div className="Statistics_StatCryptoCards">
            <div className="Statistics_CryptoTitleBtn">
              <div className="Statistics_CryptoCardTitle">Top Crypto Coins</div>
              <div className="Statistics_CryptoOuterButton">
                <div className="Statistics_EmptyCColorBtn"></div>
                <Link
                  to={CURRENCY}
                  onClick={() => {
                    this.props.NavTab(2);
                  }}
                >
                  <button className="Statistics_CryptoInnerButton">
                    See More
                  </button>
                </Link>
              </div>
            </div>

            {/* Css of this component is written in _currencies.scss file */}
            <div className="Currencies_CryptoCardsBlock">
              {coins.map((coinData, index) => {
                if (coinData.length !== 0)
                  return (
                    <React.Fragment key={index}>
                      {this.cryptoCards(coinData)}
                    </React.Fragment>
                  );
                return <React.Fragment key={index}></React.Fragment>;
              })}
            </div>
          </div>

          {/* News Cards */}
          <div className="Statistics_StatNewsCards">
            <div className="Statistics_NewsTitleBtn">
              <div className="Statistics_NewsCardTitle">Top Crypto News</div>
              <div className="Statistics_NewsOuterButton">
                <div className="Statistics_EmptyCColorBtn"></div>
                <Link
                  to={NEWS}
                  onClick={() => {
                    this.props.NavTab(5);
                  }}
                >
                  <button className="Statistics_NewsInnerButton">
                    See More
                  </button>
                </Link>
              </div>
            </div>

            {/* Css of this component is written in _news.scss file */}
            <div className="News_NewsCardsBlock">
              {news.map((newsData, index) => {
                if (newsData.length !== 0)
                  return (
                    <React.Fragment key={index}>
                      {this.newsCard(newsData)}
                    </React.Fragment>
                  );
                return <React.Fragment key={index}></React.Fragment>;
              })}
            </div>
          </div>
        </div>

        <div className="CurrencyDetails_bg">
          <img src={box4} alt="" className="CurrencyDetails_box" />
          <div className="CurrencyDetails_cir"></div>
          <div className="CurrencyDetails_cir2"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currencyData: state.appData.currencyData,
    currencyStatus: state.appData.currencyStatus,

    newsData: state.appData.newsData,
    newsStatus: state.appData.newsStatus,
  };
};

export default connect(mapStateToProps, {
  ClearLogs,
  getCurrency,
  getNews,
  NavTab,
})(Statistics);
